export const outletUrlBlocklist = [
    'apps.apple.com',
    'books.apple.com',
    'itunes.apple.com',
    'music.apple.com',
    'play.itunes.apple.com',
    'podcasts.apple.com',
    'tv.apple.com',
    'bbb.org',
    'cnet.com',
    'deezer.com',
    'etsy.com',
    'etsy.me',
    'facebook.com',
    'facebook.net',
    'fb.com',
    'fbcdn.com',
    'fbcdn.net',
    'fbsbx.com',
    'messenger.com',
    'tfbnw.net',
    'instagram.com',
    'medium.com',
    'redd.it',
    'reddit.com',
    'redditstatic.com',
    'open.spotify.com',
    'spoti.fi',
    'spotify.app.link',
    'spotify.com',
    'spotify.link',
    'www.spotify.com',
    'threads.com',
    'threads.net',
    'w.wiki',
    'wikidata.org',
    'wikimedia.org',
    'wikipedia.org',
    'x.com',
    'yelp.ca',
    'yelp.co.uk',
    'yelp.com',
    'yelp.com.au',
    'yelp.de',
    'yelp.fr',
    'yelp.to',
    'kids.youtube.com',
    'm.youtube.com',
    'music.youtube.com',
    'studio.youtube.com',
    'tv.youtube.com',
    'youtu.be',
    'youtube-nocookie.com',
    'youtube.ca',
    'youtube.co.in',
    'youtube.co.jp',
    'youtube.co.uk',
    'youtube.com',
    'youtube.com.au',
    'youtube.com.br',
    'youtube.com.mx',
    'youtube.de',
    'youtube.es',
    'youtube.fr',
    'youtube.it',
    'youtube.jp',
    'youtube.nl',
    'youtube.pl',
    'youtube.ru',
    'youtubeeducation.com'
];

const blockedHosts = new Set(outletUrlBlocklist);

/**
 * True if the host or any of its parent domains is blocklisted,
 * e.g. 'en.wikipedia.org' and 'www.wikipedia.org' both match 'wikipedia.org'.
 */
export function isBlockedHost(host: string): boolean {
    const labels = host.toLowerCase().split('.');
    return labels.some((_, i) => blockedHosts.has(labels.slice(i).join('.')));
}
